export const LOGIN_API_SUCCESS = 'loginApiSuccess'
export const SET_LOGIN = 'logoutApi'
export const LOGIN_API_FAILURE = 'logoutApiFailure'
export const SET_USER_AUTH = 'setUserAuth'
export const SIGNUP_START = 'signUpStart'
export const SIGNUP_END = 'signUpEnd'
export const SIGNUP_SUCCESS = 'signUpSuccess'
export const SIGNUP_FAIL = 'signUpFail'